import React from 'react';
import Card from '../components/UI/Card';
import { PageTransition } from '@/components/motion';

function Research() {
  return (
    <PageTransition>
      <div className="p-8">
        <Card title="Research">
          <div className="text-center py-20">
            <div className="text-5xl mb-4">🔭</div>
            <p className="text-muted-foreground mb-2">Research tools coming soon</p>
            <p className="text-sm text-muted-foreground/70">Fundamental analysis, news feeds, and market research.</p>
          </div>
        </Card>
      </div>
    </PageTransition>
  );
}

export default Research;
